<template>
  <main class="instant-points">
    <span>points to be issued instantly</span>
    <input type="text" class="item-name-input" :value="payload.bonus_value" @change="changedPointsIssued" data-cy="instant-points-name-input"/>

    <section v-if="!loadingPreload">
      <div v-if="!preload" class="attachment-container">
        <a v-file-upload:png,gif,jpeg="changedPreload" style="margin-bottom:3px" data-cy="digital-voucher-preload-image-button">preload image</a>
        <span>sends with your text</span>
      </div>

      <div v-if="preload" class="attachment-container">
        <span>preload image</span>
        <img :src="preload.thumb" alt="preload image" />
        <span class="remove-btn" @click="clickedRemovePreload" data-cy="digital-voucher-preload-image-remove-button">remove</span>
      </div>
    </section>

    <loading-icon v-if="loadingPreload" />
  </main>
</template>

<script>
export default {
  name: "instant-points",
  props: {
    payload: Object,
    preload: Object,
    loadingPreload: Boolean
  },
  methods: {
    changedPointsIssued(event) {
      this.$emit('update:payload', { bonus_value:event.target.value });
    },
    changedPreload(file) {
      this.$emit('update:preload', file);
    },
    clickedRemovePreload() {
      this.$emit('update:preload', null)
    },
  }
}
</script>

<style scoped>
.instant-points {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-right: 10px;
  width: 100%;
}

.instant-points, .attachment-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.attachment-container {
  color: #4a4a4a;
  font-size: 14px;
  font-family: AileronThin;
}

img {
  height: 75px;
  border: 1px solid #128ff9;
}

input {
  width: 100%;
}
</style>
